import React, { useEffect, useState } from 'react';
import {
  Step,
  Stepper,
  StepLabel,
  Button,
  Container,
  Grid,
  Typography,
  TextField,
  Stack,
  Checkbox,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  FormControlLabel
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { Box } from '@mui/system';
import { useDispatch } from 'react-redux';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from 'react-icons/hi';

// table component
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { MdUploadFile, MdUpload } from 'react-icons/md';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { pdfjs, Page as Pages } from 'react-pdf';

import photoDummy from './dummy/photoDummy.jpg';
import aadharFrontDummy from './dummy/aadharFrontDummy.jpg';
import aadharBackDummy from './dummy/aadharBackDummy.png';
import panCardDummy from './dummy/panCardDummy.jpg';
// import pages
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import '../styles/alicestyle.css';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { JourneyApi } from '../../utils/Apis';
import { saveApiData } from '../../store/Slice/Global/GlobalSlice';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function ViewJourneyTemplate() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeStep, setActiveStep] = useState(0);
  const [journeyData, setJourneyData] = useState(null);
  const [journeyWizardsData, setJourneyWizardsData] = useState([]);
  const [loaderMsg, setLoaderMsg] = useState('Loading... Please wait');
  const [loaderBox, setLoaderBox] = useState(false);

  const { LoginData } = useLoginSelector();

  const previewNext = () => {
    setActiveStep((activeStep) => activeStep + 1);
  };
  const previewPrev = () => {
    setActiveStep((activeStep) => activeStep - 1);
  };

  const finishJourney = (type) => {
    if (type === 'finish') {
      setLoaderMsg('Your Application is Successfully Submitted');
      setLoaderBox(true);
    } else if (type === 'onlyNext') {
      setActiveStep((activeStep) => activeStep + 1);
    } else {
      setActiveStep((activeStep) => activeStep - 1);
    }
  };

  useEffect(async () => {
    const authJourneyTemplateId = localStorage.getItem('journeyTemplateId');
    if (authJourneyTemplateId !== null) {
      const credentials = {
        companyId: LoginData?.companyId,
        templateId: Number(authJourneyTemplateId),
        userId: LoginData?.userId
      };

      try {
        const res = await dispatch(saveApiData(JourneyApi?.TemplateView, credentials));
        if (res?.status === 'success') {
          let journeyReviewCombineData = [];
          res?.data.journeyTemplateViewData.journeyWizards.forEach((journeyWizardsItem) => {
            journeyWizardsItem.selectedCards.forEach((item) => {
              item.selectedFields.forEach((fieldsItem) => {
                // fieldsItem.isOpen = false;
                fieldsItem.isOpenPopUp = false;
                fieldsItem.selectedFieldData = null;
                fieldsItem.fileBack = null;
                fieldsItem.kycInputBack = null;
                fieldsItem.file = null;
                fieldsItem.kycInput = null;
                fieldsItem.kycPassProcted = 'No';
                // fieldsItem.isProvideLater = false;
                // fieldsItem.isUnableToSubmit = false;
                fieldsItem.remarks = null;
              });
            });
          });
          journeyReviewCombineData = res?.data.journeyTemplateViewData.journeyWizards;
          if (res?.data.journeyTemplateViewData.journeyReviewWizard !== null) {
            if (res?.data.journeyTemplateViewData.journeyReviewWizard.wizardDescription === null) {
              res.data.journeyTemplateViewData.journeyReviewWizard.wizardDescription =
                res.data.journeyTemplateViewData.journeyReviewWizard.wizardName;
            }
            journeyReviewCombineData.push(res?.data.journeyTemplateViewData.journeyReviewWizard);
          }
          setJourneyData(journeyReviewCombineData);
          setJourneyWizardsData(journeyReviewCombineData);
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    }
  }, []);

  return (
    <Page title="Partner Managemet System || Journey">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Add New Journey" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          {journeyData && (
            <Box>
              <Box mb={3}>
                <Button
                  variant="outlined"
                  onClick={(e) => {
                    navigate(`/journey/template`);
                  }}
                >
                  Back to Journey-Templates
                </Button>
              </Box>

              <Stepper
                connector=""
                activeStep={activeStep}
                sx={{ marginBottom: '25px' }}
                className="stepWizardOuter"
              >
                {journeyData.map((item, index) => (
                  <Step className="stepWizard">
                    <StepLabel className="stepWizardLabel">{item?.wizardDescription}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <PreviewComponent
                journeyData={journeyData}
                // wizardsDetails={journeyWizardsData}
                activeStep={activeStep}
                previewNext={previewNext}
                previewPrev={previewPrev}
                journeyWizardsData={journeyWizardsData}
                setJourneyWizardsData={setJourneyWizardsData}
                finishJourney={finishJourney}
              />
            </Box>
          )}
        </Box>

        <Dialog open={loaderBox}>
          <Box
            display="flex"
            width={400}
            height={200}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            p={4}
          >
            <Typography textAlign="left" mt={3}>
              {loaderMsg}
            </Typography>
            <Box paddingTop="1.5rem">
              <Button
                onClick={(e) => setLoaderBox(false)}
                className="mainBtn"
                style={{ minWidth: 'auto', cursor: 'pointer' }}
                variant="contained"
              >
                Ok
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Container>
    </Page>
  );
}

export default ViewJourneyTemplate;

function PreviewComponent({
  journeyData,
  activeStep,
  previewPrev,
  journeyWizardsData,
  setJourneyWizardsData,
  finishJourney
}) {
  const [docPrevFlag, setDocPrevFlag] = useState({
    flag: false,
    srcPath: null,
    imgaltTag: null
    // contentType: null
  });

  let isHeaderRendered = false;
  const padTop = '0px';
  let borderBottomo = '';
  let documentBox = 0;

  const uploadKycBackFile = () => {
    const browseField = document.getElementById('kycBackUploader');
    browseField.click();
  };

  const uploadKycFile = () => {
    const browseField = document.getElementById('kycUploader');
    browseField.click();
  };

  const handleClose = (x, y, z) => {
    const prevData = journeyWizardsData;
    prevData[x].selectedCards[y].selectedFields[z].isOpen = false;
    prevData[x].selectedCards[y].selectedFields[z].isOpenPopUp = false;
    prevData[x].selectedCards[y].selectedFields[z].fileBack = null;
    prevData[x].selectedCards[y].selectedFields[z].kycInputBack = null;
    prevData[x].selectedCards[y].selectedFields[z].file = null;
    prevData[x].selectedCards[y].selectedFields[z].kycInput = null;
    prevData[x].selectedCards[y].selectedFields[z].kycPassProcted = 'No';
    prevData[x].selectedCards[y].selectedFields[z].isProvideLater = false;
    prevData[x].selectedCards[y].selectedFields[z].isUnableToSubmit = false;
    prevData[x].selectedCards[y].selectedFields[z].remarks = null;
    setJourneyWizardsData({ ...prevData });
  };

  const docPrevHandler = (type, srcData) => {
    if (type === 'open') {
      const responseData = JSON.parse(srcData);
      setDocPrevFlag({
        flag: true,
        srcPath: responseData.src,
        imgaltTag: responseData.alt
        // contentType: responseData.contentType
      });
    } else {
      setDocPrevFlag({
        flag: false,
        srcPath: null,
        imgaltTag: null
        // contentType: null
      });
    }
  };

  return (
    <Grid item xs="12" sm="6" mt={3}>
      {journeyData[activeStep].wizardCode !== 'REVIEW' ? (
        journeyData[activeStep]?.selectedCards.map((wizItem, wizItemIndex) => (
          <>
            <Grid item xs="12" sm="6" md="6" mt={2}>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                {wizItem?.cardCurrentTitle}
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={5}>
                <Grid container spacing={3}>
                  {wizItem?.selectedFields.map((selectedField, selectedFieldIndex) => {
                    if (
                      selectedField?.storedField?.documentMap !== null &&
                      selectedField?.storedField !== null
                    ) {
                      documentBox += 1;
                    }

                    if (wizItem?.selectedFields.length === selectedFieldIndex + 1) {
                      borderBottomo = '0px';
                    }

                    if (selectedFieldIndex >= 1) {
                      isHeaderRendered = true;
                    } else {
                      isHeaderRendered = false;
                    }

                    return wizItem.masterCardModel.cardType.typeCode === 'DOCUMENT' ? (
                      <Grid item xs={12} style={{ paddingTop: padTop }}>
                        <Box>
                          <TableContainer
                            component={Paper}
                            sx={{ borderRadius: '0.5rem 0.5rem 0 0', marginBottom: '0' }}
                          >
                            {!isHeaderRendered && (
                              <Typography variant="body2" marginBottom={2} marginTop={2}>
                                For faster processing of your application form, please scan and
                                upload a pdf/jpg file for the documents mentioned below. You will be
                                required to submit the original documents for verification by Real
                                Value Finloans.
                              </Typography>
                            )}

                            <Table aria-label="customized table" size="small" padding="normal">
                              {!isHeaderRendered && (
                                <TableHead className="tableHead">
                                  <TableRow>
                                    <TableCell style={{ width: '30%' }}>Documents</TableCell>
                                    <TableCell style={{ width: '15%' }}>Action</TableCell>
                                    <TableCell style={{ width: '15%' }}>
                                      Will Provide Later
                                    </TableCell>
                                    <TableCell style={{ width: '15%' }}>Unable to Submit</TableCell>
                                    <TableCell style={{ width: '20%' }}>Remarks</TableCell>
                                  </TableRow>
                                </TableHead>
                              )}

                              <TableBody>
                                <TableRow key={selectedFieldIndex}>
                                  <TableCell style={{ width: '30%', borderBottom: borderBottomo }}>
                                    {
                                      selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldName
                                    }
                                    <Typography variant="span" color="error">
                                      *
                                    </Typography>
                                  </TableCell>
                                  <TableCell style={{ width: '15%', borderBottom: borderBottomo }}>
                                    <IconButton
                                      aria-label="Example"
                                      className="docIcon"
                                      onClick={(e) => {
                                        const prevData = journeyWizardsData;
                                        prevData[activeStep].selectedCards[
                                          wizItemIndex
                                        ].selectedFields[selectedFieldIndex].isOpen = true;
                                        setJourneyWizardsData({ ...prevData });
                                      }}
                                    >
                                      <MdUploadFile />
                                    </IconButton>
                                  </TableCell>
                                  <TableCell style={{ width: '15%', borderBottom: borderBottomo }}>
                                    <Checkbox
                                      size="small"
                                      checked={
                                        journeyWizardsData[activeStep].selectedCards[wizItemIndex]
                                          .selectedFields[selectedFieldIndex].isProvideLater
                                      }
                                      disabled={
                                        journeyWizardsData[activeStep].selectedCards[wizItemIndex]
                                          .selectedFields[selectedFieldIndex].isUnableToSubmit
                                      }
                                      onChange={(e) => {
                                        const prevData = journeyWizardsData;
                                        prevData[activeStep].selectedCards[
                                          wizItemIndex
                                        ].selectedFields[selectedFieldIndex].isProvideLater =
                                          e.target.checked;
                                        setJourneyWizardsData({ ...prevData });
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell style={{ width: '15%', borderBottom: borderBottomo }}>
                                    <Checkbox
                                      size="small"
                                      checked={
                                        journeyWizardsData[activeStep].selectedCards[wizItemIndex]
                                          .selectedFields[selectedFieldIndex].isUnableToSubmit
                                      }
                                      disabled={
                                        journeyWizardsData[activeStep].selectedCards[wizItemIndex]
                                          .selectedFields[selectedFieldIndex].isProvideLater
                                      }
                                      onChange={(e) => {
                                        const prevData = journeyWizardsData;
                                        prevData[activeStep].selectedCards[
                                          wizItemIndex
                                        ].selectedFields[selectedFieldIndex].isUnableToSubmit =
                                          e.target.checked;
                                        setJourneyWizardsData({ ...prevData });
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell style={{ width: '20%', borderBottom: borderBottomo }}>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      inputProps={{
                                        className: 'formControl formControlRemark'
                                      }}
                                      placeholder="Remarks"
                                      value={
                                        journeyWizardsData[activeStep].selectedCards[wizItemIndex]
                                          .selectedFields[selectedFieldIndex].remarks
                                      }
                                      onChange={(e) => {
                                        const prevData = journeyWizardsData;
                                        prevData[activeStep].selectedCards[
                                          wizItemIndex
                                        ].selectedFields[selectedFieldIndex].remarks =
                                          e.target.value;
                                        setJourneyWizardsData({ ...prevData });
                                      }}
                                    />
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                        <Dialog
                          className="PopupBox"
                          open={
                            journeyWizardsData[activeStep].selectedCards[wizItemIndex]
                              .selectedFields[selectedFieldIndex].isOpen
                          }
                          onClose={() => handleClose(activeStep, wizItemIndex, selectedFieldIndex)}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                        >
                          <DialogTitle
                            id="alert-dialog-title"
                            className="popupHeading"
                            style={{ marginBottom: '0px', borderBottom: '1px solid #efefef' }}
                          >
                            <Typography variant="h6" className="popupTitle">
                              Upload Document
                            </Typography>
                            <IconButton
                              onClick={() =>
                                handleClose(activeStep, wizItemIndex, selectedFieldIndex)
                              }
                              size="small"
                            >
                              <CloseIcon />
                            </IconButton>
                          </DialogTitle>

                          <DialogContent dividers className="PopupContent">
                            <DialogContentText id="alert-dialog-description">
                              <FormControl sx={{ width: '100%' }}>
                                <RadioGroup
                                  aria-labelledby="demo-radio-buttons-group-label"
                                  defaultValue="Local File"
                                  name="radio-buttons-group"
                                >
                                  <Box
                                    container
                                    style={{
                                      padding: '6px',
                                      marginBottom: '9px',
                                      border: '1px solid #efefef',
                                      borderRadius: '5px'
                                    }}
                                  >
                                    <Box className="uploadPopupInnerRow">
                                      <FormControlLabel
                                        value="Local File"
                                        control={<Radio size="small" />}
                                        label=""
                                        sx={{ marginRight: '0.5rem' }}
                                      />
                                      <Typography variant="caption" className="UploadPopupIcon">
                                        <MdUpload className="UploadIcon" />
                                      </Typography>
                                      <Typography
                                        variant="body1"
                                        marginRight={1}
                                        className="FileTypeName"
                                      >
                                        Local Files
                                      </Typography>
                                      <input
                                        id="kycUploader"
                                        className="Fileupload hideForView"
                                        onChange={(e) => {
                                          const filename = e.target.files[0];
                                          const prevData = journeyWizardsData;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].selectedFields[selectedFieldIndex].file = filename;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].selectedFields[selectedFieldIndex].kycInput =
                                            filename.name;
                                          setJourneyWizardsData({ ...prevData });
                                        }}
                                        type="file"
                                      />
                                      <ShowInputBox
                                        val={
                                          journeyWizardsData[activeStep].selectedCards[wizItemIndex]
                                            .selectedFields[selectedFieldIndex].kycInput
                                        }
                                      />
                                      <Button
                                        type="button"
                                        onClick={uploadKycFile}
                                        className="uploadBtn"
                                      >
                                        Browse
                                      </Button>
                                    </Box>

                                    {selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldCode === 'AADHAR_CARD' ? (
                                      <Box className="uploadPopupInnerRow">
                                        <FormControlLabel
                                          value="Local File"
                                          control={<Radio size="small" />}
                                          label=""
                                          sx={{ marginRight: '0.5rem' }}
                                        />
                                        <Typography variant="caption" className="UploadPopupIcon">
                                          <MdUpload className="UploadIcon" />
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          marginRight={1}
                                          className="FileTypeName"
                                        >
                                          Local Files
                                        </Typography>
                                        <input
                                          id="kycBackUploader"
                                          className="Fileupload hideForView"
                                          onChange={(e) => {
                                            const filename = e.target.files[0];
                                            const prevData = journeyWizardsData;
                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].selectedFields[selectedFieldIndex].fileBack =
                                              filename;
                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].selectedFields[selectedFieldIndex].kycInputBack =
                                              filename.name;
                                            setJourneyWizardsData({ ...prevData });
                                          }}
                                          type="file"
                                        />
                                        <TextField
                                          value={
                                            journeyWizardsData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].selectedFields[selectedFieldIndex].kycInputBack
                                          }
                                          inputProps={{ className: 'TextField' }}
                                          className="TextFieldGroup"
                                        />
                                        <Button
                                          type="button"
                                          onClick={uploadKycBackFile}
                                          className="uploadBtn"
                                        >
                                          Browse
                                        </Button>
                                      </Box>
                                    ) : (
                                      ''
                                    )}

                                    <FormControl className="PassProtectB" defaultValue="No">
                                      <FormLabel
                                        id="demo-row-radio-buttons-group-label"
                                        sx={{ marginRight: '0.5rem' }}
                                      >
                                        Is your file password protected?
                                      </FormLabel>
                                      <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        value={
                                          journeyWizardsData[activeStep].selectedCards[wizItemIndex]
                                            .selectedFields[selectedFieldIndex].kycPassProcted
                                        }
                                        onChange={(e) => {
                                          const prevData = journeyWizardsData;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].selectedFields[selectedFieldIndex].kycPassProcted =
                                            e.target.value;
                                          setJourneyWizardsData({ ...prevData });
                                        }}
                                      >
                                        <FormControlLabel
                                          value="Yes"
                                          control={<Radio size="small" />}
                                          label="Yes"
                                        />
                                        <FormControlLabel
                                          value="No"
                                          control={<Radio size="small" />}
                                          label="No"
                                        />
                                      </RadioGroup>
                                    </FormControl>
                                    {journeyWizardsData[activeStep]?.selectedCards[wizItemIndex]
                                      ?.selectedFields[selectedFieldIndex]?.kycPassProcted ===
                                      'Yes' && (
                                      <TextField
                                        className="TextFieldGroup"
                                        inputProps={{ className: 'TextField' }}
                                        fullWidth="true"
                                      />
                                    )}
                                  </Box>
                                  <Box
                                    container
                                    style={{
                                      padding: '6px',
                                      marginBottom: '9px',
                                      border: '1px solid #efefef',
                                      borderRadius: '5px'
                                    }}
                                  >
                                    <Box className="uploadPopupInnerRow">
                                      <FormControlLabel
                                        value="Google Drive"
                                        control={<Radio size="small" />}
                                        label=""
                                        sx={{ marginRight: '0.5rem' }}
                                      />
                                      <Typography variant="caption" className="UploadPopupIcon">
                                        <img
                                          src="../static/icons/googleDrive.svg"
                                          alt="Google Drive"
                                        />
                                      </Typography>
                                      <Typography variant="body1" className="FileTypeName">
                                        Google Drive
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <Box
                                    container
                                    style={{
                                      padding: '6px',
                                      marginBottom: '9px',
                                      border: '1px solid #efefef',
                                      borderRadius: '5px'
                                    }}
                                  >
                                    <Box className="uploadPopupInnerRow">
                                      <FormControlLabel
                                        value="Dropbox"
                                        control={<Radio size="small" />}
                                        label=""
                                        sx={{ marginRight: '0.5rem' }}
                                      />
                                      <Typography variant="caption" className="UploadPopupIcon">
                                        <img src="../static/icons/dropBox.svg" alt="Drop Box" />
                                      </Typography>
                                      <Typography variant="body1" className="FileTypeName">
                                        Dropbox
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <Box
                                    container
                                    style={{
                                      padding: '6px',
                                      marginBottom: '9px',
                                      border: '1px solid #efefef',
                                      borderRadius: '5px'
                                    }}
                                  >
                                    <Box className="uploadPopupInnerRow">
                                      <FormControlLabel
                                        value="Digiloker"
                                        control={<Radio size="small" />}
                                        label=""
                                        sx={{ marginRight: '0.5rem' }}
                                      />
                                      <Typography variant="caption" className="UploadPopupIcon">
                                        <img
                                          src="../static/icons/digilocker.svg"
                                          alt="Digi Locker"
                                        />
                                      </Typography>
                                      <Typography variant="body1" className="FileTypeName">
                                        DigiLocker
                                      </Typography>
                                    </Box>
                                  </Box>
                                </RadioGroup>
                              </FormControl>
                              <Typography>
                                Note: The file types supported format type is PDF, JPEG & PNG. The
                                maximum uploaded file size is 10MB.
                              </Typography>
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={(e) =>
                                handleClose(activeStep, wizItemIndex, selectedFieldIndex)
                              }
                              className="mainBtn"
                            >
                              Upload
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Grid>
                    ) : (
                      <Grid item xs={4}>
                        <Box className="">
                          <Typography variant="h6" className="formLabel">
                            {selectedField.cardFieldMapping.journeyCardFieldsMaster.fieldName}
                          </Typography>
                          {selectedField.cardFieldMapping.journeyCardFieldsMaster.fieldType
                            .typeCode === 'DROPDOWN' ? (
                            <Select
                              fullWidth
                              inputProps={{
                                className: `textInput customSelectBox dissabledMenu${selectedField?.storedField?.value}`
                              }}
                              id={selectedField.cardFieldMapping.journeyCardFieldsMaster.fieldId}
                              value={JSON.stringify(selectedField?.storedField?.value)}
                            >
                              <MenuItem
                                value={JSON.stringify(selectedField?.storedField?.value)}
                                disabled
                              >
                                {`Select ${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}`}
                              </MenuItem>
                            </Select>
                          ) : selectedField.cardFieldMapping.journeyCardFieldsMaster.fieldType
                              .typeCode === 'DATE' ? (
                            <TextField
                              type="date"
                              fullWidth
                              id={selectedField.cardFieldMapping.journeyCardFieldsMaster.fieldId}
                              inputProps={{
                                className: 'textInput'
                              }}
                              placeholder={
                                selectedField.cardFieldMapping.journeyCardFieldsMaster.fieldName
                              }
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                            />
                          ) : selectedField.cardFieldMapping.journeyCardFieldsMaster.fieldType
                              .typeCode === 'NUMBER_FIELD' ? (
                            <TextField
                              type="number"
                              fullWidth
                              inputProps={{
                                className: 'textInput'
                              }}
                              id={selectedField.cardFieldMapping.journeyCardFieldsMaster.fieldId}
                              placeholder={
                                selectedField.cardFieldMapping.journeyCardFieldsMaster.fieldName
                              }
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                            />
                          ) : (
                            <TextField
                              fullWidth
                              inputProps={{
                                className: 'textInput'
                              }}
                              id={selectedField.cardFieldMapping.journeyCardFieldsMaster.fieldId}
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                              placeholder={
                                selectedField.cardFieldMapping.journeyCardFieldsMaster.fieldName
                              }
                            />
                          )}
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            </Grid>
            {journeyData[activeStep]?.selectedCards.map((selectedField, selectedFieldIndex) => {
              if (selectedFieldIndex >= 1) {
                isHeaderRendered = true;
              } else {
                isHeaderRendered = false;
              }
              return wizItem?.masterCardModel?.cardType?.typeCode === 'DOCUMENT' ? (
                <Box mb={3}>
                  {!isHeaderRendered && (
                    <Box>
                      <Typography variant="body1" className="headingLineUp headingLineUpOut">
                        Uploaded {wizItem?.cardCurrentTitle}
                      </Typography>
                      <Box className="viewLeadCard cardTopMinusMargin">
                        <Box className="displayFlex flexWrap" style={{ marginTop: '-15px' }}>
                          {journeyData[activeStep]?.selectedCards.map((selectedFieldItem) =>
                            selectedFieldItem.selectedFields.map((selectedFieldsItem) => (
                              <>
                                <Box
                                  className="uploadFilePreview"
                                  mt={2}
                                  onClick={() => {
                                    const imgDetailsObj = {};
                                    imgDetailsObj.alt =
                                      selectedFieldsItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName;
                                    if (
                                      selectedFieldsItem?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'PHOTOGRAPH'
                                    ) {
                                      imgDetailsObj.src = photoDummy;
                                      imgDetailsObj.contentType = '';
                                    } else if (
                                      selectedFieldsItem?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'AADHAR_CARD'
                                    ) {
                                      imgDetailsObj.src = aadharFrontDummy;
                                      imgDetailsObj.contentType = '';
                                    } else if (
                                      selectedFieldsItem?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'PAN_CARD' ||
                                      selectedFieldsItem?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'COMPANY_PAN_CARD'
                                    ) {
                                      imgDetailsObj.src = panCardDummy;
                                      imgDetailsObj.contentType = '';
                                    }

                                    docPrevHandler('open', JSON.stringify(imgDetailsObj));
                                  }}
                                >
                                  <RemoveRedEyeIcon className="ImageViewIcon" />
                                  <Typography variant="body2" className="uploadFileText">
                                    {
                                      selectedFieldsItem?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldName
                                    }
                                  </Typography>
                                </Box>
                                {selectedFieldsItem?.cardFieldMapping?.journeyCardFieldsMaster
                                  ?.fieldCode === 'AADHAR_CARD' ? (
                                  <Box
                                    className="uploadFilePreview"
                                    mt={2}
                                    onClick={() => {
                                      const imgDetailsObj = {};
                                      imgDetailsObj.alt =
                                        selectedFieldsItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName;
                                      imgDetailsObj.src = aadharBackDummy;
                                      imgDetailsObj.contentType = '';
                                      docPrevHandler('open', JSON.stringify(imgDetailsObj));
                                    }}
                                  >
                                    <RemoveRedEyeIcon className="ImageViewIcon" />
                                    <Typography variant="body2" className="uploadFileText">
                                      {`Back ${selectedFieldsItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}`}
                                    </Typography>
                                  </Box>
                                ) : (
                                  ''
                                )}
                              </>
                            ))
                          )}
                        </Box>
                      </Box>
                    </Box>
                  )}
                </Box>
              ) : (
                ''
              );
            })}
          </>
        ))
      ) : (
        <Box>
          {journeyData[activeStep]?.reviewCards.map((wizItem) => (
            <Box>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                {wizItem.reviewCardHeading}
              </Typography>

              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Grid container spacing={3}>
                  {wizItem.selectedJourneyReviewCards.map((selectedJourneyReviewCardsItem) =>
                    selectedJourneyReviewCardsItem?.selectedJourneyCard?.masterCardModel?.cardType
                      ?.typeCode !== 'DOCUMENT'
                      ? selectedJourneyReviewCardsItem.reviewCardFields.map((reviewItem) => (
                          <Grid item xs={4}>
                            <Box className="displayFlex">
                              <img
                                style={{
                                  width: '45px',
                                  marginRight: '15px',
                                  borderRadius: '5px'
                                }}
                                src={reviewItem.reviewCardFieldIcon}
                                alt=""
                              />
                              <Box>
                                <Typography variant="body2" className="labelText">
                                  {reviewItem.reviewCardFieldHeading !== null
                                    ? reviewItem?.reviewCardFieldHeading
                                    : reviewItem?.cardDetail?.cardFieldMapping
                                        ?.journeyCardFieldsMaster?.fieldName}
                                </Typography>
                                <Typography variant="subtitle2" className="labelValue">
                                  {reviewItem.reviewCardFieldHeading !== null
                                    ? reviewItem?.reviewCardFieldHeading
                                    : reviewItem?.cardDetail?.cardFieldMapping
                                        ?.journeyCardFieldsMaster?.fieldName}
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                        ))
                      : selectedJourneyReviewCardsItem.reviewCardFields.map(
                          (reviewItem, reviewIndex) => (
                            <Box
                              className="displayFlex flexWrap"
                              ml={reviewIndex === 0 ? 3 : ''}
                              mt={2}
                            >
                              <Box
                                className="uploadFilePreviewBox uploadFilePreviewGreen uploadFilePreview"
                                onClick={() => {
                                  const imgDetailsObj = {};
                                  if (
                                    reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                      .fieldCode === 'AADHAR_CARD'
                                  ) {
                                    imgDetailsObj.src = '../static/dummy/aadharFrontDummy.jpg';
                                  } else if (
                                    reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                      .fieldCode === 'PAN_CARD' ||
                                    reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                      .fieldCode === 'COMPANY_PAN_CARD'
                                  ) {
                                    imgDetailsObj.src = '../static/dummy/panCardDummy.jpg';
                                  } else if (
                                    reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                      .fieldCode === 'PHOTOGRAPH'
                                  ) {
                                    imgDetailsObj.src = '../static/dummy/photoDummy.jpg';
                                  } else {
                                    imgDetailsObj.src =
                                      '../static/dummy/certificateIncorporation.jpg';
                                  }
                                  // imgDetailsObj.src = reviewItem.reviewCardFieldIcon;
                                  imgDetailsObj.alt =
                                    reviewItem.reviewCardFieldHeading !== null
                                      ? reviewItem?.reviewCardFieldHeading
                                      : reviewItem?.cardDetail?.cardFieldMapping
                                          ?.journeyCardFieldsMaster?.fieldName;
                                  // imgDetailsObj.contentType = reviewItem.contentType;
                                  docPrevHandler('open', JSON.stringify(imgDetailsObj));
                                }}
                              >
                                <RemoveRedEyeIcon className="ImageViewIcon" />
                                <Typography variant="body2" className="docName">
                                  {reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                    .fieldCode === 'AADHAR_CARD'
                                    ? `${
                                        reviewItem.reviewCardFieldHeading !== null
                                          ? reviewItem?.reviewCardFieldHeading
                                          : reviewItem?.cardDetail?.cardFieldMapping
                                              ?.journeyCardFieldsMaster?.fieldName
                                      } - Front`
                                    : reviewItem.reviewCardFieldHeading !== null
                                    ? reviewItem?.reviewCardFieldHeading
                                    : reviewItem?.cardDetail?.cardFieldMapping
                                        ?.journeyCardFieldsMaster?.fieldName}
                                </Typography>
                              </Box>

                              {reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                .fieldCode === 'AADHAR_CARD' ? (
                                <Box
                                  className="uploadFilePreviewBox uploadFilePreviewGreen uploadFilePreview"
                                  onClick={() => {
                                    const imgDetailsObj = {};
                                    imgDetailsObj.src = '../static/dummy/aadharBackDummy.png';
                                    imgDetailsObj.alt =
                                      reviewItem.reviewCardFieldHeading !== null
                                        ? reviewItem?.reviewCardFieldHeading
                                        : reviewItem?.cardDetail?.cardFieldMapping
                                            ?.journeyCardFieldsMaster?.fieldName;
                                    docPrevHandler('open', JSON.stringify(imgDetailsObj));
                                  }}
                                >
                                  <RemoveRedEyeIcon className="ImageViewIcon" />
                                  <Typography variant="body2" className="docName">
                                    {reviewItem.reviewCardFieldHeading !== null
                                      ? reviewItem?.reviewCardFieldHeading
                                      : reviewItem?.cardDetail?.cardFieldMapping
                                          ?.journeyCardFieldsMaster?.fieldName}{' '}
                                    - Back
                                  </Typography>
                                </Box>
                              ) : (
                                ''
                              )}
                            </Box>
                          )
                        )
                  )}
                </Grid>
              </Box>
            </Box>
          ))}
        </Box>
      )}

      <Dialog
        className="PopupBox"
        open={docPrevFlag.flag}
        onClose={() => docPrevHandler('close', '')}
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="popupHeading" style={{ borderBottom: '0px', marginBottom: '0px' }}>
          <Typography variant="h6" className="popupTitle" style={{ paddingBottom: '0px' }}>
            Document Preview
          </Typography>
          <IconButton onClick={() => docPrevHandler('close', '')} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers className="PopupContent">
          <DialogContentText>
            <img src={docPrevFlag.srcPath} alt={docPrevFlag.imgaltTag} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="mainBtn" onClick={() => docPrevHandler('close', '')}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ display: 'flex' }} mb={2}>
        {activeStep > 0 ? (
          journeyData[activeStep].wizardCode !== 'REVIEW' ? (
            <Button
              onClick={() => {
                previewPrev();
              }}
              startIcon={<HiOutlineArrowNarrowLeft />}
              className="mainBtn previousBtn"
            >
              Back
            </Button>
          ) : (
            <Button
              onClick={() => finishJourney('backWithoutApi')}
              startIcon={<HiOutlineArrowNarrowLeft />}
              className="mainBtn previousBtn"
            >
              Back
            </Button>
          )
        ) : (
          ''
        )}
        {journeyData.length - 1 === activeStep ? (
          <Button
            onClick={() => finishJourney('finish')}
            className="mainBtn"
            variant="contained nextBtn"
          >
            Finish
          </Button>
        ) : (
          <Button
            onClick={() => finishJourney('onlyNext')}
            className="mainBtn"
            endIcon={<HiOutlineArrowNarrowRight />}
            variant="contained nextBtn"
          >
            Next
          </Button>
        )}
      </Box>
    </Grid>
  );
}

function ShowInputBox({ val }) {
  useEffect(() => {}, [val]);
  return (
    <TextField value={val} inputProps={{ className: 'TextField' }} className="TextFieldGroup" />
  );
}
